import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment.dev';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (environment.production) {
      window.console.log = () => {};
    }

    window.onbeforeunload = () => {
      localStorage.clear();
    };
  })
  .catch((err) => console.error(err));
